module.exports = __webpack_public_path__ + "static/img/baoshijie.507dc157.png";